// extracted by mini-css-extract-plugin
export default {"Box":"y-axis-selector-module__Box--CY1uI","SelectorLabel":"y-axis-selector-module__SelectorLabel--yIpg8","ActionMenu_Button":"y-axis-selector-module__ActionMenu_Button--UvyqT"};